var map = {
	"./arrow-black.png": 535,
	"./arrow.png": 536,
	"./buffer.png": 537,
	"./checkbox_off.png": 538,
	"./checkbox_on.png": 539,
	"./circle.png": 540,
	"./closeX.gif": 950,
	"./collapsed.png": 541,
	"./color-picker.png": 542,
	"./compass.png": 543,
	"./default.png": 544,
	"./down.png": 545,
	"./edit-all.png": 546,
	"./edit-move.png": 547,
	"./edit-rotate.png": 548,
	"./edit-scale.png": 549,
	"./edit-vertices.png": 550,
	"./edit.png": 551,
	"./editing_labe_cfd_idro.png": 552,
	"./editing_labe_prtc.png": 553,
	"./eraser.png": 554,
	"./freehandLine.png": 555,
	"./icon.png": 556,
	"./identify.png": 557,
	"./json.png": 558,
	"./line.png": 559,
	"./measure-tool.png": 560,
	"./measure.png": 561,
	"./myItemsIcon.png": 562,
	"./none.png": 563,
	"./pdf_download_red.png": 564,
	"./pin.png": 565,
	"./point.png": 566,
	"./polygon.png": 567,
	"./polyline.png": 568,
	"./rectangle.png": 569,
	"./select-all.png": 570,
	"./select-none.png": 571,
	"./settings.png": 572,
	"./symbolize.png": 573,
	"./symbolizer.png": 574,
	"./text.png": 575,
	"./toolbox.png": 576,
	"./triangle.png": 577,
	"./triangle_red.png": 578,
	"./up.png": 579,
	"./zoom.png": 580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1538;